import { SiteData } from "components/WebDesigner/Data/SiteData";
import { Fragment, useEffect, useState } from "react";
import { GetSetCategories, GetSetList, SetType } from "./SetLibraryAPI";
import { AlertConfirm } from "components/WebDesigner/ConfirmationPopups";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import ReactDOM from "react-dom";
import { ColorSet } from "./SetLibraryMenu";
import Loader from "vagaro-website-rendering/src/components/Common/Loader";

export default function ColorPalletePopUp({siteData,onSelect}:{siteData:SiteData,onSelect:(colors:string[])=>void}){

    const [colorPallets,setColorPallets] = useState<string[][]>([]);
    const [filters,setFilters] = useState<string[]>([]);
    const [categories,setCategories] = useState<{id:string,name:string}[]>([]);
    const [isLoading,setIsLoading] = useState(true);
    const loadPallets = async ()=>{

        setIsLoading(true);
        await GetSetList(siteData.userContext,SetType.Color,filters.join(","),(data:any)=>{
          
            let pallets = data?.data?.data??[];

            let palletArr = [];
            for(let i = 0;i<pallets.length;i++){
                let pallet = pallets[i];
                try{
                    let colors = JSON.parse(pallet.content);
                    palletArr.push(colors);
                }
                catch(e){
                    console.warn("error parsing pallet");
                }
            }
            setColorPallets(palletArr);

        },(data:any)=>{
          
            AlertConfirm("Error","There was an error loading the color pallets. Please try again later.");
        },123)

        await   GetSetCategories(siteData.userContext,SetType.Color,(data:any) => {


            let categories = data?.data?.data??[];
            console.log("Data",data);
            setCategories(categories);
     
        },(error:any) => {
            AlertConfirm("Error","There was an error loading the color pallets. Please try again later.");

        });

        setIsLoading(false);

        
    }

    useEffect(()=>{

        loadPallets();
//eslint-disable-next-line
    },[filters])


    return <div className="flex-col h-full">
        {isLoading && <Loader/>}
        <div className="cat-chip-row" style={{marginTop:"0"}}>
                     <div className={"cat-chip "+(filters.length===0?"selected":"")} onClick={(e)=>{
                            setFilters([]);
                        }}>{"All"}</div>

                {
                    categories.map((cat,index)=>{
                        return <div className={"cat-chip "+(filters.includes(cat.id)?"selected":"")} key={index} onClick={(e)=>{
                            if(filters.includes(cat.id)){
                                setFilters(filters.filter((id)=>id!==cat.id));
                            }
                            else{
                                setFilters([...filters,cat.id]);
                            }
                        }}>{cat.name}</div>
                    })
                }
        </div>
        <div className="flex-row flex-wrap align-start" style={{minHeight:"50vh"}}>
            {
                colorPallets.map((pallet,index)=>{

                    return <div className="color-set-wrapper vanimation-fade-in" style={{height:"94px",padding:"8px",animationDelay:(index*0.02)+"s"}}
                    onClick={(e)=>{onSelect(pallet)}}
                    ><ColorSet key={index} colors={pallet} overridHeight="78px" /></div>

                })

            }
        </div>

    </div>

}

export function OpenColorPalletPopup(siteData:SiteData,onSelect:(colors:string[])=>void){
    
    const dom =  document.getElementById("OpenDialog");
   
    const PopUpClose = ()=>{
        if(dom){
            ReactDOM.unmountComponentAtNode(dom);
        }
    }

    let SelectWrapper = (colors:string[])=>{
        PopUpClose();
        onSelect(colors);
    }

    ReactDOM.render( // render style inline to avoid  bloat in main.cs file
        <>
        <style>
            {`
            #pallet-popup{
                max-width:80vw;
            }

            .color-set-wrapper{
                width:33.333%;
                cursor:pointer;
                border-radius:8px;
                opacity:0;
            }
            
            .color-set-wrapper:hover{
                background-color:#f0f0f0;
            }

            @media (min-width:1400px) {
                .color-set-wrapper{
                    width:25%;
                }
            }

            .cat-chip-row{
                display: flex;
                
                margin-top: 20px;
                overflow: auto;
            
            
            }

            .cat-chip{
                border: none;
                background: white;
                color: #333;
                margin-right: 16px;
                margin-bottom: 8px;
                padding: 10px 16px;
                border: 1px solid #CDCDCD;
                border-radius: 50px;
                font-size: 16px;
                white-space: nowrap;
                font-weight: 400;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: background .2s;
        
            }
        
            .cat-chip.selected, .cat-chip:hover{
                background: #444;
                color: white;
           
            }  
            
            `}
        </style>
        <VGPopUp
          id={"pallet-popup"}
          show={true}
          onHide={PopUpClose}
          title={"Select a Preset Palette"}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <ColorPalletePopUp siteData={siteData} onSelect={SelectWrapper}/>
            </div>
          }
          footer={
            <Fragment>
             
            <button className="w-button w-button-secondary" onClick={(e) => { PopUpClose();}}>Cancel</button>
            </Fragment >
          }
          isRemoveTabModalIndex={false}
          isShowFooter={true}
          size={"modal-lg"}
          backdrop={true}
        />
  
        </>,
        dom);

}